import React from 'react';
import PropTypes from 'prop-types';
import { FaAngleRight as AngleRightIcon } from 'react-icons/fa';
import DropdownMenu from '../shared/dropdownMenu';

const DropdownSubMenu = ({ children, label }) => (
  <ul className="navbar-nav mr-auto">
    <li className="nav-item menu-item w-100">
      <DropdownMenu
        className="dropdown--submenu w-100"
        trigger={
          <div className="submenu-trigger pl-3">
            {label}
            <AngleRightIcon className="ml-3"/>
          </div>
        }
        openOnHover
      >
        {children}
      </DropdownMenu>
    </li>
  </ul>
);

DropdownSubMenu.propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.string.isRequired,
};

export default DropdownSubMenu;
